import noty from '@/plugins/noty'

export const staleExtensionNotification = noty({
  type: 'warning',
  timeout: 10000,
  text: 'For the best performance please <a href="https://docs.jiminny.com/integrations/google-chrome/updating-the-chrome-extension" target="_blank">update your Jiminny Chrome Extension</a>. Thanks'
})



// WEBPACK FOOTER //
// ./src/components/extension-version-checker/notifications.js